import React,{Component} from "react";
import { Field, reduxForm } from "redux-form";
import { Form, FormGroup, Button, Label, Row, Col, UncontrolledTooltip, CardBody, CardFooter } from "reactstrap";
import { renderField, renderCheckbox, required, number } from "../../../utils/formValidations.js";
import { connect } from "react-redux";
import { getGroups , updateGroups } from "../../../actions/actionGroup";
import { NotificationManager } from "react-notifications";
import { withRouter } from "react-router-dom";
import Proptypes from "prop-types";

class GroupFormTemplate extends Component  {
    constructor(props){
        super(props);
        this.state  = {
            currentGroup: null,
        };
        this.submitGroup= this.submitGroup.bind(this);
        this.cancelButton = this.cancelButton.bind(this);
        this.handleUpdateSuccess = this.handleUpdateSuccess.bind(this);
        this.handleCreateSuccess = this.handleCreateSuccess.bind(this);
        this.initializeForm = this.initializeForm.bind(this);
    }

    handleUpdateSuccess(){
        const {errorMessageUpdateGroup} = this.props;
        if(errorMessageUpdateGroup){
            NotificationManager.error(errorMessageUpdateGroup,"Update Group", 3000);        
        }
        else {
            NotificationManager.success("Group Update", "Successfully Updated Groups");
            this.props.history.push("/groups");
        }
    }

    handleUpdateError(){
        const {updateGroupsError} = this.props;
        if(updateGroupsError){
            NotificationManager.error(updateGroupsError,"Update Group", 3000);
        }
    }


    handleCreateSuccess(){
        const {errorMessage} = this.props; 
        if(errorMessage){
            NotificationManager.error(errorMessage,"Create Group", 3000);
        }
        else{
            NotificationManager.success("Group Created", "Successfully Created Group");
            this.props.history.push("/groups");
            this.props.getAdminUsers();
        }
    }

    handleCreateError(){
        const {createGroupsError} = this.props;
        if(createGroupsError){
            NotificationManager.warning(createGroupsError,"Create Group", 3000);
        }
    }

    submitGroup(userData){
        if (this.props.fromUpdate){
            userData.group_id = this.props.groupId;
            this.props.updateGroups(userData).
                then(() => this.handleUpdateSuccess()).
                catch(() => this.handleUpdateError());
        }
        else {
            this.props.createGroup(userData).
                then(() => this.handleCreateSuccess()).
                catch(() => this.handleCreateError());
        }
    }

    initializeForm(res){
        let currentGroup = res.response.groups.find(groups => groups.group_id === this.props.groupId);
        this.setState({currentGroup: currentGroup});
        this.props.initialize({
            group_dn: currentGroup.group_dn,
            description: currentGroup.description, 
            is_ldap_group: currentGroup.is_ldap_group,
            is_system: currentGroup.is_system,
            name: currentGroup.name,
            priority: currentGroup.priority,
            is_saml_group: currentGroup.is_saml_group,
            saml_group: currentGroup.saml_group
        });
    }

    cancelButton(){
        this.props.history.push("/groups");
    }

    componentDidMount(){
        if (this.props.fromUpdate){
            this.props.getGroups().then((res) => this.initializeForm(res));
        }
    }

    render(){
        const {handleSubmit, groupFormValues, availableKasms} = this.props;
        const {currentGroup} =  this.state;
        const checked = currentGroup && currentGroup.is_ldap_group;
        return (
            <Form onSubmit={handleSubmit(this.submitGroup)}>
                <CardBody>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="name" className="requiredasterisk">Name</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="name" 
                                    id="name" 
                                    component={renderField} 
                                    validate={required}
                                /> 
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="description">Description</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field 
                                    type="description"
                                    name="description" 
                                    id="description" 
                                    component={renderField}
                                /> 
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <UncontrolledTooltip placement="right" target={"TooltipComponent"}>
                            When a user belongs to multiple groups and settings in those groups overlap, the group with the lowest priority will win.
                                </UncontrolledTooltip>
                                <Label htmlFor="priority" className="requiredasterisk"><span id={"TooltipComponent"}>Priority</span></Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field 
                                    type="number"
                                    name="priority" 
                                    id="priority" 
                                    component={renderField} 
                                    validate={[required, number]}
                                    placeholder="10"
                                /> 
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="is_ldap_group">LDAP Group</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label check htmlFor="is_ldap_group">            
                                    <Field name="is_ldap_group" 
                                        id="is_ldap_group" 
                                        type ="checkbox"
                                        checked = {checked}
                                        component={renderCheckbox}
                                    />
                                </Label>
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="group_dn">LDAP Group DN</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field 
                                    type="group_dn"
                                    name="group_dn" 
                                    id="group_dn" 
                                    component={renderField} 
                                    validate={ groupFormValues && groupFormValues.is_ldap_group ? required : null}
                                    placeholder="e.g. CN=GroupName,OU=Employees,DC=example,DC=local"
                                /> 
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="is_saml_group">SAML Group</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label check htmlFor="is_saml_group">
                                    <Field name="is_saml_group"
                                           id="is_saml_group"
                                           type ="checkbox"
                                           checked = {checked}
                                           component={renderCheckbox}
                                    />
                                </Label>
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="saml_group">SAML Group Name</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field
                                    type="saml_group"
                                    name="saml_group"
                                    id="saml_group"
                                    component={renderField}
                                    validate={ groupFormValues && groupFormValues.is_saml_group ? required : null}
                                    placeholder="e.g. admins, users"
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                </CardBody>               
                <CardFooter>
                    <FormGroup className="form-actions">
                        <Button className="cancel-button" type="cancel" size="sm" color="basic" onClick={() => this.cancelButton()}> Cancel</Button>
                        <Button type="submit" size="sm" 
                        className="submit-button"
                        color="primary"> Submit</Button>
                    </FormGroup>
                </CardFooter>
            </Form>
        );
    }
}

GroupFormTemplate.propTypes = {
    history: Proptypes.object.isRequired,
    createGroup: Proptypes.func,
    updateGroups: Proptypes.func,
    updateGroupsError:  Proptypes.func,
    getGroups: Proptypes.func.isRequired,
    createGroupWarning: Proptypes.string,
    getAdminUsers: Proptypes.func,
    handleSubmit: Proptypes.func,
    createGroupsError: Proptypes.string,
    fromUpdate: Proptypes.bool,
    errorMessage: Proptypes.string,
    errorMessageUpdateGroup: Proptypes.string,
    groupFormValues: Proptypes.object,
    getGroupsLoading: Proptypes.bool,
    userId: Proptypes.func,
    initialize: Proptypes.func,
    groupId: Proptypes.string,
    groups: Proptypes.array,

};

let GroupFormWithRouter = withRouter(GroupFormTemplate);

let GroupForm =  connect(state => 
    ({
        groups: state.groups.groups || [],
        groupFormValues: state.form && state.form.groupForm && state.form.groupForm.values ? state.form.groupForm.values : null,
        getGroupsLoading: state.admin.getGroupsLoading || false,
        errorMessage: state.groups.errorMessage || null,
        errorMessageUpdateGroup: state.groups.errorMessageUpdateGroup || null,
        updateGroupsError: state.groups.updateGroupsError || null,
        createGroupsError: state.groups.createGroupsError || null,
        createGroupWarning: state.groups.createGroupWarning || null,
    }),
dispatch => 
    ({
        updateGroups: (data) => dispatch(updateGroups(data)),
        getGroups: () => dispatch(getGroups()),
    }))(GroupFormWithRouter);

export default reduxForm({
    form: "groupForm",
})(GroupForm);


// WEBPACK FOOTER //
// ./src/views/Groups/GroupForm/GroupForm.js